import * as React from "react";
import type { SVGProps } from "react";
const SvgDeleteCircle = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={21}
    height={20}
    fill="none"
    viewBox="0 0 21 20" {...props}
  >
    <path
      stroke="#0D1B27"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeOpacity={0.87}
      d="m13.108 7.64-4.716 4.717M13.108 12.357 8.392 7.641"
    />
    <path
      stroke="#0D1B27"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeOpacity={0.87}
      d="M10.75 17.5a7.5 7.5 0 0 1-7.5-7.5v0a7.5 7.5 0 0 1 7.5-7.5v0a7.5 7.5 0 0 1 7.5 7.5v0a7.5 7.5 0 0 1-7.5 7.5"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgDeleteCircle;
